import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const QRPaymentLoadable = Loadable({
    loader: () => import('desktop/containers/QRPayment/QRPayment.js' /* webpackChunkName: 'qrPayment' */).then(module => module.default),
    loading: () => <Loader />
});

export default QRPaymentLoadable;
